import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { firstListItem } from '@/constants/defaultValues';
import { getLabel } from '@/helpers/Utils';

export const fetchEmployeeStatus = createAsyncThunk(
  'employeeStatus/fetchEmployeeStatus',
  async (params, thunkAPI) => {
    try {
      const response = await Lookup.GetEmployeeStatus();
      const mappedData =
        response?.data?.data?.map((item) => ({
          id: item.id,
          nameEn: item.nameEn,
          nameAr: item.nameAr,
          code: item.code,
          label: item.name,
          value: item.id,
          isDefaultValue: item.isDefaultValue,
        })) ?? [];
      return [firstListItem, ...mappedData];
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const initialState = {
  employeeStatusList: [],
  loading: false,
  error: '',
};

const employmentStatusSlice = createSlice({
  name: 'employeeStatus',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchEmployeeStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchEmployeeStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.employeeStatusList = action.payload;
        state.error = '';
      })
      .addCase(fetchEmployeeStatus.rejected, (state, action) => {
        state.loading = false;
        state.employeeStatusList = [];
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export default employmentStatusSlice.reducer;
